import React, { useMemo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { style as questionTitleStyle } from "./QuestionTitle.style";
const textMainProps = {
    variant: "heading",
    level: 3,
};
const textDefaultProps = {
    variant: "body",
    level: 3,
};
const QuestionTitle = ({ domain, level, translationKey, segment, style: customStyle }) => {
    const titleText = useI18nMessage({ domain, id: translationKey, values: { segment: segment.toLowerCase() } });
    const isMain = level === 0;
    const props = isMain ? textMainProps : textDefaultProps;
    const style = useMemo(() => questionTitleStyle(), []);
    return (React.createElement(Text, { style: [style.text, isMain && style.textMain, customStyle], ...props }, titleText));
};
export { QuestionTitle };
